import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import HomeScreen from "./components/pages/home";
import Header from "./components/inc/Header";
import Footer from "./components/inc/Footer";
import TermsAndConditionsScreen from "./components/pages/termsandConditions";
import PrivacyScreen from "./components/pages/privacy";
function ScrollToTopMain() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
function App() {
  return (
    // <Router basename={"/wolfpack"}>
    <Router basename={"/"}>
      <ScrollToTopMain />
      <Header />
      <Routes>
        <Route path="/" exact element={<HomeScreen />} />
        <Route
          path="/terms-and-conditions"
          exact
          element={<TermsAndConditionsScreen />}
        />
        <Route path="/privacy" exact element={<PrivacyScreen />} />
      </Routes>
      <Footer />
    </Router>
  );
}
export default App;
